import React from "react";
import { MapPin, Pencil } from "lucide-react";
import { formatAddressLines } from "../../utils/formatAddress";

const Address = ({ address, setNewAddress }) => {
  const item = address?.length > 0 ? address[0] : null;
  if (!item) return null;

  const { name, streetLine, secondaryLine } = formatAddressLines(item);

  return (
    <div className="address-class">
      <div className="address-data">
        <button
          type="button"
          className="address-card address-card--active"
          onClick={setNewAddress}
          aria-label="עריכת כתובת למשלוח"
        >
          <span className="address-card__icon" aria-hidden>
            <MapPin size={18} strokeWidth={2} />
          </span>
          <span className="address-card__content">
            {name ? <span className="address-card__name">{name}</span> : null}
            {streetLine ? (
              <span className="address-card__line">{streetLine}</span>
            ) : null}
            {secondaryLine ? (
              <span className="address-card__line address-card__line--muted">
                {secondaryLine}
              </span>
            ) : null}
          </span>
          <span className="address-card__edit" aria-hidden>
            <Pencil size={14} strokeWidth={2} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Address;
